import React from 'react';
export type Verdict = 'Permitted' | 'Permitted with conditions' | 'Verification required' | 'Not permitted' | 'Exceeds limit' | 'Not applicable' | 'Inconclusive' | 'Pass' | 'Fail';
interface VerdictBadgeProps {
  verdict: Verdict;
  className?: string;
}
const styles: Record<Verdict, string> = {
  Permitted: 'bg-forest-green/10 text-forest-green ring-1 ring-inset ring-forest-green/20',
  Pass: 'bg-forest-green/10 text-forest-green ring-1 ring-inset ring-forest-green/20',
  'Permitted with conditions': 'bg-amber-100 text-amber-800 ring-1 ring-inset ring-amber-200',
  Inconclusive: 'bg-amber-100 text-amber-800 ring-1 ring-inset ring-amber-200',
  'Verification required': 'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200',
  'Not applicable': 'bg-slate-100 text-slate-500 ring-1 ring-inset ring-slate-200',
  'Not permitted': 'bg-red-100 text-red-700 ring-1 ring-inset ring-red-200',
  'Exceeds limit': 'bg-red-100 text-red-700 ring-1 ring-inset ring-red-200',
  Fail: 'bg-red-100 text-red-700 ring-1 ring-inset ring-red-200'
};
export function VerdictBadge({
  verdict,
  className = ''
}: VerdictBadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${styles[verdict]} ${className}`} data-id="element-2582" data-mp="2t941wevfb2dj">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-2583" data-mp="334xge3spd5xy" />
      {verdict}
    </span>;
}